import { Card } from "@jhool-io/fe-components";
import Logo from "../../../../shared-ui/Logo/Logo";

interface AuthWrapperProps {
    children: React.ReactNode;
    footer: React.ReactElement;
}

export default function AuthWrapper({ children, footer }: AuthWrapperProps) {
    return (
        <>
            <div className="top-5 right-5 absolute">
                <a
                    href="https://docs.google.com/document/d/1BDxPqNJQbg4O8ZOuQ6mM4Q2yj-iUijIBXYC6-6XHjhc/edit?usp=sharing"
                    target="_blank"
                    rel="noreferrer"
                    className="link text-caption [border:1px_solid_var(--color-stroke)]  !border !border-stroke"
                >
                    Frequently Asked Questions{" "}
                    <svg
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="size-4"
                    >
                        <line x1="7" y1="17" x2="17" y2="7" />
                        <polyline points="7 7 17 7 17 17" />
                    </svg>
                </a>
            </div>
            <div className="flex items-center justify-center h-dvh mx-auto page">
                <Card classNames="w-[400px] max-w-full">
                    <div>
                        <div className="mb-[--spacing-items]">
                            <Logo />
                        </div>
                        {children}
                    </div>
                    <footer className="mt-[--spacing-items]">{footer}</footer>
                </Card>
            </div>
        </>
    );
}
